import React, { ReactNode, useContext } from 'react';

import { classNames } from '../../utils/style';
import Less from '../../foundations/pictograms/less.svg';
import More from '../../foundations/pictograms/more.svg';
import { AccordionContext } from '../../components/Accordion/AccordionContext';

export interface QuestionAnswerProps {
  question: string;
  answer: ReactNode | string;
  onClick?: any;
}

export interface FaqQuestionProps {
  children: ReactNode;
  classNameIcon?: string;
}

export const FaqQuestion = ({
  children,
  classNameIcon = 'h-20 w-20',
}: FaqQuestionProps) => {
  const { open } = useContext(AccordionContext);
  return (
    <>
      {children}
      <span className="FaqIcon pr-[10px] pl-24 h-6 w-6 relative">
        <More
          className={classNames(
            'transition duration-200',
            'transform absolute top-0 right-0',
            'fill-[#96A3B3]',
            open && `rotate-180 opacity-0`,
            classNameIcon,
          )}
        />

        <Less
          className={classNames(
            'h-6 w-6 transition duration-200',
            'transform opacity-0 absolute top-0 right-0',
            open && `rotate-180 opacity-100`,
            'fill-[#96A3B3]',
            classNameIcon,
          )}
        />
      </span>
    </>
  );
};
